import React from "react";
import { Row, Col } from "react-bootstrap";
import "./starRating.scss";
import ModalCustom from "../Modal/ModalCustomDesign";
import okIcon from "../../../../src/assets/noun_Check.svg";

export default function MessageBox(props) {
  return (
    <ModalCustom
      show={true}
      size={"lg"}
      className="custom-modal-message-design"
    >
      <div id="star-rating-container-div" className="container pb-5 pt-5">
        {/* <div className="d-flex ai-center header-div">
          <div
            className="ml-auto close-conatiner"
            onClick={() => props.closeHandler()}
          >
            Close
            <i className="fa fa-close pl-1" aria-hidden="true"></i>
          </div>
        </div> */}

        <Row className="m-0 mb-4 message-body-div">
          <span className="w-100-imp text-center">
            {/* <i
              className="fa fa-check-circle circle-icon"
              aria-hidden="true"
            ></i> */}
            <div className="ok_icon">
              <img src={okIcon} alt="" />
            </div>
            <div className="message-title pb-2 pt-3">Thank you!</div>
            <div className="">Your feedback helps us improve our platform.</div>
          </span>
        </Row>

        <div className="d-flex p-0">
          <button
            className="star-rating-button m-auto"
            onClick={() => props.successHandler()}
          >
            Okay
          </button>
        </div>
      </div>
    </ModalCustom>
  );
}
